import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { EOrientation } from '@Managers/Device/UseWindowDimensions.types';
import { GameStore } from '@GameStore/GameStore';
import { IModifier } from './Modifier';
import { getAllEventModifiers } from '@Core/Utils/ModifierUtils';
import { EAnimationModifiers } from '@Core/Animation/SpineWrapperEventManager';

export class OrientationModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        const currentOrientation = this.gameStore.get(EGameStoreKeys.CurrentOrientation);
        const orientationSuffix = currentOrientation === EOrientation.LANDSCAPE ? EAnimationModifiers.LANDSCAPE : EAnimationModifiers.PORTRAIT;

        return getAllEventModifiers(name).includes(orientationSuffix);
    }
}
